export const WATCH_PLATFORM_APPLE = "apple_watch"
export const WATCH_PLATFORM_WEAR_OS = "wear_os"

const STANDALONE_SOURCES = [WATCH_PLATFORM_APPLE, WATCH_PLATFORM_WEAR_OS]
const COMPANION_SOURCES = ["phone_with_apple_watch", "phone_with_wear_os"]

export function currentWatchPlatform() {
  if (typeof window !== "undefined") {
    try {
      if (window.localStorage?.getItem("isAndroid") === "true" || /Android/i.test(window.navigator?.userAgent || "")) {
        return WATCH_PLATFORM_WEAR_OS
      }
    } catch (_) {
      // Der Plattform-Fallback darf den Trainingsfluss nicht blockieren.
    }
  }
  return WATCH_PLATFORM_APPLE
}

export function watchPlatformFromSource(source, fallbackPlatform = null) {
  if ([WATCH_PLATFORM_WEAR_OS, "phone_with_wear_os"].includes(source)) return WATCH_PLATFORM_WEAR_OS
  if ([WATCH_PLATFORM_APPLE, "phone_with_apple_watch"].includes(source)) return WATCH_PLATFORM_APPLE
  return fallbackPlatform === WATCH_PLATFORM_WEAR_OS ? WATCH_PLATFORM_WEAR_OS : WATCH_PLATFORM_APPLE
}

export function isWatchWorkoutSource(source) {
  return STANDALONE_SOURCES.includes(source) || COMPANION_SOURCES.includes(source)
}

export function isStandaloneWatchSource(source) {
  return STANDALONE_SOURCES.includes(source)
}

export function phoneCompanionWorkoutSource(platform = currentWatchPlatform()) {
  return platform === WATCH_PLATFORM_WEAR_OS ? "phone_with_wear_os" : "phone_with_apple_watch"
}

export function watchDeviceLabel(source = null, fallbackPlatform = null) {
  return watchPlatformFromSource(source, fallbackPlatform || currentWatchPlatform()) === WATCH_PLATFORM_WEAR_OS
    ? "Watch"
    : "Apple Watch"
}

export function watchHealthSourceLabel(source = null, fallbackPlatform = null) {
  return watchPlatformFromSource(source, fallbackPlatform || currentWatchPlatform()) === WATCH_PLATFORM_WEAR_OS
    ? "Health Services"
    : "HealthKit"
}

export function hasDirectWatchRecording(execution) {
  return isWatchWorkoutSource(execution?.source) ||
    [WATCH_PLATFORM_APPLE, WATCH_PLATFORM_WEAR_OS].includes(execution?.watchData?.platform) ||
    Boolean(execution?.watchData?.health?.healthKitWorkoutId)
}
